import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hasForumSubscription } from '../utils/forumAccess';

/**
 * Hook to check forum subscription and redirect if no access
 * @returns {Object} { hasAccess, loading }
 */
export const useForumAccess = () => {
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        setLoading(true);
        const hasSubscription = await hasForumSubscription();
        setHasAccess(hasSubscription);

        if (!hasSubscription) {
          navigate('/subscription-feature-required?module=discussion_forum', { replace: true });
        }
      } catch (error) {
        console.error('Error checking forum access:', error);
        setHasAccess(false);
        navigate('/subscription-feature-required?module=discussion_forum', { replace: true });
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [navigate]);

  return { hasAccess, loading };
};
